import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs-make";
import "./component.scss";

export default class extends Controller {
  static targets = ["sortableList"];

  static values = {
    canEdit: Boolean,
    reorderUrlTemplate: String,
  };

  connect() {
    this.scrollToActiveItem();
    this.setupSortable();
  }

  disconnect() {
    this.destroySortable();
  }

  scrollToActiveItem() {
    const activeItem = this.element.querySelector('[class*="--active"]');
    if (activeItem) {
      activeItem.scrollIntoView({
        behavior: "auto",
        block: "nearest",
      });
    }
  }

  setupSortable() {
    if (this.hasSortableListTarget && this.canEditValue) {
      this.sortable = Sortable.create(this.sortableListTarget, {
        animation: 150,
        handle: "[data-playlist-handle]",
        filter: "[data-sortable-exclude]",
        fallbackOnBody: true,
        forceFallback: true,
        swapThreshold: 0.85,
        onMove: (event) => {
          return !event.related.hasAttribute("data-sortable-exclude");
        },
        onStart: () => {
          this.sortableListTarget.style.userSelect = "none";
        },
        onEnd: (...args) => {
          this.sortableListTarget.style.userSelect = "";
          this.onReorder(...args);
        },
      });
    }
  }

  destroySortable() {
    if (this.sortable) {
      this.sortable.destroy();
      this.sortable = null;
    }
  }

  onReorder(event) {
    const id = event.item.dataset.playlistItemId;
    const newPosition = event.newIndex + 1;
    const url = this.reorderUrlTemplateValue.replace("__ID__", id);

    this.patchReorder(url, newPosition);
  }

  get csrfToken() {
    return document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");
  }

  patchReorder(url, newPosition) {
    const data = new FormData();
    data.append("playlist_item[new_position]", newPosition);

    fetch(url, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": this.csrfToken,
      },
      body: data,
    })
      .then((response) => {
        if (!response.ok) throw new Error("Reorder failed");
      })
      .catch((error) => {
        console.error("Reorder error:", error);
        const frame = this.element.closest("turbo-frame");
        if (frame && frame.src) frame.src = frame.src;
      });
  }
}
